import type { FC } from 'react';
import React from 'react';

interface IProps {
    className?: string;
    fill?: string;
    size?: string;
}

export const HintIcon: FC<IProps> = ({ className, fill = '#121212', size = '16' }) => (
    <svg
        className={className}
        data-test-id="hint-icon"
        fill="none"
        height={size}
        viewBox="0 0 16 16"
        width={size}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M8.85145 11.9961V7H7.15487V11.9961H8.85145Z" fill={fill} />
        <path
            d="M9.08984 4.91016C9.08984 5.51206 8.6019 6 8 6C7.3981 6 6.91016 5.51206 6.91016 4.91016C6.91016 4.30825 7.3981 3.82031 8 3.82031C8.6019 3.82031 9.08984 4.30825 9.08984 4.91016Z"
            fill={fill}
        />
        <path
            clipRule="evenodd"
            d="M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8ZM14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
            fill={fill}
            fillRule="evenodd"
        />
    </svg>
);
